import { ReactElement, useState } from 'react';
import { Input, Button } from 'antd';
import { ButtonRow } from './ButtonRow.style';

const { TextArea } = Input;

interface Props {
  defaultValue: string;
  onSave: (value: string) => void;
  onCancel: () => void;
  loading?: boolean;
}

const SummaryForm = ({ defaultValue, onSave, onCancel, loading = false }: Props): ReactElement => {
  const [value, setValue] = useState(defaultValue);
  const isDisabled = loading || value.trim() === '';

  const handleSave = (): void => {
    const trimmed = value.trim();
    if (trimmed !== '') {
      onSave(trimmed);
    }
  };

  return (
    <>
      <TextArea
        value={value}
        onChange={e => {
          setValue(e.target.value);
        }}
        autoSize={{ minRows: 4, maxRows: 10 }}
        disabled={loading}
      />
      <ButtonRow>
        <Button type='primary' onClick={handleSave} loading={loading} disabled={isDisabled}>
          保存
        </Button>
        <Button onClick={onCancel} disabled={loading}>
          キャンセル
        </Button>
      </ButtonRow>
    </>
  );
};

export default SummaryForm;
